import React from 'react';
import { Card, Button, Space, Typography } from 'antd';
import { ArrowLeftOutlined, FilePdfOutlined } from '@ant-design/icons';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { ProtectedRoute, PageGuard } from '../../../components/common/security/ProtectedRoute';
import { useAuth } from '../../../components/common/security/AuthContext';

const { Title, Text } = Typography;

const AccPdfViewer: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const projectId = searchParams.get('projectId') || '';
  const itemId = searchParams.get('itemId') || '';
  const { token } = useAuth();

  const apiBase = `http://${window.location.hostname}:5000/api`;

  const src =
    projectId && itemId && token
      ? `${apiBase}/acc/projects/${encodeURIComponent(
          projectId,
        )}/items/${encodeURIComponent(
          itemId,
        )}/download?token=${encodeURIComponent(token)}`
      : '';

  return (
    <ProtectedRoute>
      <PageGuard>
        <div style={{ padding: 24, height: '100%', display: 'flex', flexDirection: 'column' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
            <Space>
              <Button icon={<ArrowLeftOutlined />} onClick={() => navigate(-1)}>Back</Button>
            </Space>
            <Space>
              <FilePdfOutlined />
              <Title level={4} style={{ margin: 0 }}>PDF Viewer</Title>
            </Space>
            <div />
          </div>
          <Card bodyStyle={{ padding: 0 }} style={{ flex: 1, minHeight: 0 }}>
            {src ? (
              <iframe
                title="ACC PDF Viewer"
                src={src}
                style={{ width: '100%', height: 'calc(100vh - 200px)', border: 'none' }}
              />
            ) : (
              <div style={{ padding: 24 }}>
                <Text type="secondary">Invalid file.</Text>
              </div>
            )}
          </Card>
        </div>
      </PageGuard>
    </ProtectedRoute>
  );
};

export default AccPdfViewer;



